import { render, staticRenderFns } from "./SchemeGrouping.vue?vue&type=template&id=1dc61d40&scoped=true&"
import script from "./SchemeGrouping.vue?vue&type=script&lang=js&"
export * from "./SchemeGrouping.vue?vue&type=script&lang=js&"
import style0 from "./SchemeGrouping.vue?vue&type=style&index=0&id=1dc61d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc61d40",
  null
  
)

export default component.exports